"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CaseFillInTheBlanksCardWrapper = function CaseFillInTheBlanksCardWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "selectedWordForm", _descriptor, _this);
      _state.DeckUI.enrichSentence(_this.props.card);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "numSections",
      get: function get() {
        return this.props.cardState.revealed ? 3 : 2;
      }
    }, {
      key: "sectionHeight",
      get: function get() {
        return this.props.cardState.revealed ? _state.DeckUI.layout.heightForCardSections(this.numSections, 0, false) : _state.DeckUI.layout.heightForCardSections(this.numSections, 0, true);
      }
    }, {
      key: "selectedWord",
      get: function get() {
        var _this$props$card$sent,
          _this$props$card$sent2,
          _this2 = this;
        if (!((_this$props$card$sent = this.props.card.sentence) !== null && _this$props$card$sent !== void 0 && _this$props$card$sent.wordAssociations)) return null;
        return (_this$props$card$sent2 = this.props.card.sentence.wordAssociations.find(function (wa) {
          return _this2.props.card.wordAssociationIds.includes(wa.id);
        })) === null || _this$props$card$sent2 === void 0 ? void 0 : _this$props$card$sent2.word;
      }
    }, {
      key: "correctAnswer",
      get: function get() {
        var _this$props$card$sent3,
          _this3 = this;
        if (!((_this$props$card$sent3 = this.props.card.sentence) !== null && _this$props$card$sent3 !== void 0 && _this$props$card$sent3.wordAssociations)) return '';
        var targetWordAssociation = this.props.card.sentence.wordAssociations.find(function (wa) {
          return _this3.props.card.wordAssociationIds.includes(wa.id);
        });
        return (targetWordAssociation === null || targetWordAssociation === void 0 ? void 0 : targetWordAssociation.targetText) || '';
      }
    }, {
      key: "customPrompt",
      get: function get() {
        return 'Fill in the blank with the correct form';
      }
    }, {
      key: "topSectionText",
      get: function get() {
        if ((0, _utils.isPresent)(this.props.card.prompt)) {
          return this.props.card.prompt;
        } else if ((0, _utils.isPresent)(this.props.card.sentence)) {
          return this.props.card.sentence.sourceTextForUser(_state.DeckUI.user);
        }
      }
    }, {
      key: "topSectionLanguageId",
      get: function get() {
        if ((0, _utils.isPresent)(this.props.card.sentence)) {
          return this.props.card.sentence.sourceTextForUserLanguageId(_state.DeckUI.user);
        }
      }
    }, {
      key: "getIncorrectFormsFromChildWords",
      value: function getIncorrectFormsFromChildWords(rootWord, correctAnswer) {
        if (!rootWord.childWordsList) return [];
        var allForms = rootWord.childWordsList.split(',').map(function (form) {
          return form.trim();
        });
        return allForms.filter(function (form) {
          return form && form !== correctAnswer && form.slice(-2) !== correctAnswer.slice(-2);
        });
      }
    }, {
      key: "getDeclensionFormsFromList",
      value: function getDeclensionFormsFromList(rootWord, correctAnswer) {
        var forms = [];
        if (_constants.DECLENSION_OPTIONS[rootWord.targetText]) {
          var declensionForms = _constants.DECLENSION_OPTIONS[rootWord.targetText];
          forms = declensionForms.filter(function (form) {
            return form && form !== correctAnswer;
          });
        }
        if (forms.length < 3) {
          var neededForms = 3 - forms.length;
          var allDeclensionForms = Object.values(_constants.DECLENSION_OPTIONS).flat().filter(function (form) {
            return form && form !== correctAnswer && !forms.includes(form);
          });
          var shuffledForms = _toConsumableArray(allDeclensionForms).sort(function () {
            return Math.random() - 0.5;
          });
          var additionalForms = shuffledForms.slice(0, neededForms);
          forms = [].concat(_toConsumableArray(forms), _toConsumableArray(additionalForms));
        }
        return forms;
      }
    }, {
      key: "generatePatternBasedForms",
      value: function generatePatternBasedForms(rootWord, correctAnswer, existingForms) {
        var baseForm = rootWord.targetText;
        var stem = baseForm.endsWith('e') ? baseForm.slice(0, -1) : baseForm;
        var generatedForms = [baseForm, "".concat(stem, "e"), "".concat(stem, "en"), "".concat(stem, "es"), "".concat(stem, "er"), "".concat(stem, "em")];
        return generatedForms.filter(function (form) {
          return form && form !== correctAnswer && !existingForms.includes(form);
        });
      }
    }, {
      key: "selectRandomIncorrectOptions",
      value: function selectRandomIncorrectOptions(incorrectForms) {
        var uniqueIncorrectForms = _toConsumableArray(new Set(incorrectForms));
        var shuffledIncorrect = uniqueIncorrectForms.sort(function () {
          return Math.random() - 0.5;
        });
        return shuffledIncorrect.slice(0, 3);
      }
    }, {
      key: "createOptionsArray",
      value: function createOptionsArray(correctAnswer, selectedIncorrect) {
        var options = [{
          id: correctAnswer,
          label: correctAnswer,
          correct: true
        }].concat(_toConsumableArray(selectedIncorrect.map(function (form) {
          return {
            id: form,
            label: form,
            correct: false
          };
        })));
        return options.sort(function () {
          return Math.random() - 0.5;
        });
      }
    }, {
      key: "wordFormOptions",
      get: function get() {
        var _this$selectedWord$wo;
        if (!this.selectedWord) return [];
        var rootWord = this.selectedWord.selfOrRoot;
        if (!rootWord) return [];
        var correctAnswer = this.correctAnswer;
        var wordType = (_this$selectedWord$wo = this.selectedWord.wordType) === null || _this$selectedWord$wo === void 0 ? void 0 : _this$selectedWord$wo.abbreviation;
        var incorrectForms = [];
        if (wordType !== null && wordType !== void 0 && wordType.startsWith('art') || wordType !== null && wordType !== void 0 && wordType.startsWith('pron')) {
          incorrectForms = this.getDeclensionFormsFromList(rootWord, correctAnswer);
        } else {
          incorrectForms = this.getIncorrectFormsFromChildWords(rootWord, correctAnswer);
        }
        if (incorrectForms.length < 3) {
          var neededForms = 3 - incorrectForms.length;
          var generatedForms = this.generatePatternBasedForms(rootWord, correctAnswer, incorrectForms);
          var shuffledGenerated = _toConsumableArray(generatedForms).sort(function () {
            return Math.random() - 0.5;
          });
          var selectedGeneratedForms = shuffledGenerated.slice(0, neededForms);
          incorrectForms = [].concat(_toConsumableArray(incorrectForms), _toConsumableArray(selectedGeneratedForms));
        }
        var selectedIncorrect = this.selectRandomIncorrectOptions(incorrectForms);
        return this.createOptionsArray(correctAnswer, selectedIncorrect);
      }
    }, {
      key: "isMultipleChoiceCorrect",
      get: function get() {
        return this.selectedWordForm === this.correctAnswer;
      }
    }, {
      key: "correctMessage",
      get: function get() {
        return "Correct! The answer is \"".concat(this.correctAnswer, "\".");
      }
    }, {
      key: "incorrectMessage",
      get: function get() {
        if (this.selectedWordForm) {
          return "You answered \"".concat(this.selectedWordForm, "\". The correct answer is \"").concat(this.correctAnswer, "\".");
        }
        return "The correct answer is \"".concat(this.correctAnswer, "\".");
      }
    }, {
      key: "icons",
      get: function get() {
        var ary = [];
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        if (!this.props.cardState.revealed) {
          ary.push('toggleMultipleChoice');
        }
        ary.push('caseDescription');
        return ary;
      }
    }, {
      key: "onSelectWordForm",
      value: function onSelectWordForm(wordFormItem) {
        var _this4 = this;
        this.selectedWordForm = wordFormItem.id;
        setTimeout(function () {
          return _this4.onCheckAnswerMultipleChoice();
        }, 100);
      }
    }, {
      key: "onCheckAnswerMultipleChoice",
      value: function onCheckAnswerMultipleChoice() {
        if (this.isMultipleChoiceCorrect) {
          _state.DeckUI.onCorrectAnswer(this.props.card, this.props.cardState, this.props.userCard, {
            xp: 2,
            xpSlug: 'case'
          });
        } else {
          _state.DeckUI.onIncorrectAnswer(this.props.card, this.props.cardState, this.props.userCard);
        }
        _state.DeckUI.reveal(this.props.card, this.props.cardState);
      }
    }, {
      key: "onNextClick",
      value: function onNextClick() {
        this.selectedWordForm = null;
        _state.DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          blockEvaluateVocabOnKeystroke: true,
          numSections: this.numSections,
          sectionHeight: this.sectionHeight,
          correctAnswer: this.correctAnswer,
          icons: this.icons,
          customPrompt: this.customPrompt,
          showCase: true,
          hideTextInput: true,
          topSectionText: this.topSectionText,
          topSectionLanguageId: this.topSectionLanguageId,
          wordFormOptions: this.wordFormOptions,
          selectedWordForm: this.selectedWordForm,
          correctMessage: this.correctMessage,
          incorrectMessage: this.incorrectMessage,
          onSelectWordForm: this.onSelectWordForm,
          onNextClick: this.onNextClick
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selectedWordForm", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "numSections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numSections"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "customPrompt", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "customPrompt"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "topSectionText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "topSectionText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "topSectionLanguageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "topSectionLanguageId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getIncorrectFormsFromChildWords", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getIncorrectFormsFromChildWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getDeclensionFormsFromList", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getDeclensionFormsFromList"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "generatePatternBasedForms", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "generatePatternBasedForms"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectRandomIncorrectOptions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "selectRandomIncorrectOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createOptionsArray", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "createOptionsArray"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordFormOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordFormOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isMultipleChoiceCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isMultipleChoiceCorrect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "incorrectMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "incorrectMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSelectWordForm", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSelectWordForm"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCheckAnswerMultipleChoice", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCheckAnswerMultipleChoice"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onNextClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onNextClick"), _class2.prototype), _class2)) || _class;
};
CaseFillInTheBlanksCardWrapper.displayName = 'CaseFillInTheBlanksCardWrapper';
var _default = exports["default"] = CaseFillInTheBlanksCardWrapper;